import httpClient from "../http/http-client";
import { IFactorYearReviewItem, IFactorYearReviewEmission } from "./factor-year-review.model";

export default class FactorYearReviewService {
  http;
  constructor() {
    this.http = httpClient
  }

  async getOpenItems(): Promise<{ items: IFactorYearReviewItem[] }> {
    return this.http.get(`factor-year-review-item`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getItemEmissions(id: string): Promise<{ emissions: IFactorYearReviewEmission[], totalEmissions: number, totalProvisionalCalculations: number, totalSelectedEmissionAmountKg: number }> {
    return this.http.get(`factor-year-review-item/${id}/emissions`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async dismiss(id: string): Promise<void> {
    return this.http.patch(`factor-year-review-item/${id}/dismiss`, {})
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}
